import { toIsoDate, convertParisLocalToUtc } from './dateHelpers';
import { getSpecialEvents, listenToSpecialEvents } from '../services/specialEventsService';

// Cache réactif pour les événements
let eventsCache = null;
let cacheTimestamp = 0;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
let reactiveCacheInitialized = false;

// Initialiser le cache réactif si ce n'est pas déjà fait
function initReactiveCache() {
  if (reactiveCacheInitialized) return;
  
  reactiveCacheInitialized = true;
  console.log('🔄 [eventColorHelper] Initialisation du cache réactif');
  
  // Écouter les changements Firebase en temps réel
  listenToSpecialEvents((events) => {
    console.log('🔄 [eventColorHelper] Événements mis à jour:', events.length);
    eventsCache = events || [];
    cacheTimestamp = Date.now();
  });
}

// Fonction pour obtenir la couleur d'un événement à partir d'une date ISO
export async function getEventColorForDate(isoDate) {
  try {
    // Initialiser le cache réactif
    initReactiveCache();
    
    // Si le cache réactif n'est pas encore initialisé ou est vide, charger depuis Firebase
    if (!eventsCache || eventsCache.length === 0) {
      eventsCache = await getSpecialEvents();
      cacheTimestamp = Date.now();
    }

    // Trouver l'événement correspondant à cette date
    for (const event of eventsCache) {
      let eventMeetingAt;
      
      // Si l'événement a déjà un meetingAt (timestamp), l'utiliser directement
      if (event.meetingAt) {
        eventMeetingAt = event.meetingAt;
      } else {
        // Créer une date locale (comme si c'était en heure de Paris)
        const localDate = new Date(Date.UTC(event.year, event.month - 1, event.day, event.hour, event.minute, 0, 0));
        // Convertir cette date locale de Paris en UTC
        eventMeetingAt = convertParisLocalToUtc(localDate);
      }
      
      const eventIsoDate = toIsoDate(eventMeetingAt);
      
      if (eventIsoDate === isoDate) {
        return event.color || 'orange';
      }
    }
    
    return null;
  } catch (error) {
    console.warn('⚠️ [eventColorHelper] Erreur récupération couleur événement:', error);
    return null;
  }
}

// Fonction pour convertir le nom de couleur en code hexadécimal avec opacité
export function getColorWithOpacity(colorName, opacity = 0.15) {
  const colorMap = {
    'orange': `rgba(249, 115, 22, ${opacity})`, // #f97316
    'blue': `rgba(59, 130, 246, ${opacity})`, // #3b82f6
    'green': `rgba(16, 185, 129, ${opacity})`, // #10b981
    'red': `rgba(239, 68, 68, ${opacity})`, // #ef4444
    'purple': `rgba(168, 85, 247, ${opacity})`, // #a855f7
  };
  
  return colorMap[colorName] || colorMap['orange'];
}
